import React, { useState, useMemo, useEffect, useRef } from 'react';
import { shape, string, bool, object, arrayOf } from 'prop-types';
import SlidingTabs from '../../shared/SlidingTabs';
import * as styles from './styles/styles.module.scss';
import SeoTabbedContent from './SeoTabbedContent';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { EN_US } from '../../../utils/constants/LanguageRegionCode';

const {
  strings: {
    HOME_PAGE: { ADVENTURE_ANYWHERE, TRAILS_TABBED_BLOCK }
  }
} = StringConstantsMixin;

const SeoTrailTabbed = ({ data, languageRegionCode, displayMetric, windowWidth }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const prevTabIndex = useRef(activeTabIndex);
  const [opacity, setOpacity] = useState(1);

  const tabs = useMemo(() => {
    return data.map(tab => {
      return { ...tab, label: TRAILS_TABBED_BLOCK[tab.key] };
    });
  }, [data]);

  useEffect(() => {
    prevTabIndex.current = activeTabIndex;
  }, [activeTabIndex]);

  const handleTabClick = (e, idx) => {
    e.preventDefault();
    if (idx === activeTabIndex) {
      return;
    }

    setOpacity(0);
    setActiveTabIndex(idx);
  };

  const activeContent = useMemo(() => {
    // we have a small fade between tabs here
    if (opacity === 0) {
      return tabs[prevTabIndex.current].data;
    }

    return tabs[activeTabIndex].data;
  }, [activeTabIndex, opacity]);

  const handleTransitionEnd = () => {
    if (opacity === 0) {
      setOpacity(1);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>{ADVENTURE_ANYWHERE}</div>
      <div>
        <SlidingTabs
          tabs={tabs}
          onChange={handleTabClick}
          activeIndex={activeTabIndex}
          scrollButtons={windowWidth && windowWidth >= 1240 ? 'off' : 'on'}
          slidingTabsClasses={{
            root: styles.tabsRoot,
            flexContainer: styles.flexContainer,
            scrollButtons: styles.scrollButtons,
            scroller: styles.tabsScroller
          }}
          tabClasses={{ root: styles.tabRoot, wrapper: styles.tabWrapper, selected: styles.selectedTab }}
        />
        <div className={`${styles.fader} xlate-none`} style={{ opacity }} onTransitionEnd={handleTransitionEnd}>
          <SeoTabbedContent cards={activeContent} languageRegionCode={languageRegionCode} displayMetric={displayMetric} />
        </div>
      </div>
    </div>
  );
};

SeoTrailTabbed.propTypes = {
  data: arrayOf(
    shape({
      key: string,
      data: arrayOf(object)
    })
  ),
  languageRegionCode: string,
  displayMetric: bool
};

SeoTrailTabbed.defaultProps = {
  data: [],
  languageRegionCode: EN_US,
  displayMetric: false
};

export default SeoTrailTabbed;
